module.exports = __webpack_public_path__ + "img/up-down.278a7d7a.svg";